<template>
  <div class="gd-section gd-consultation" :class="{'has-error': hasError}">
    <div class="gd-section-head">
      <span class="n">§3</span>
      <span class="t">Consulta</span>
      <span class="d">Campos 12–16 e 20–22 · um único serviço, quantidade 1</span>
    </div>
    <div class="gd-section-body">
      <div class="gd-consultation-options" v-if="showChooser">
        <div class="gd-consultation-options-hint">
          Este agendamento tem {{ items.length }} consultas pendentes · escolha a desta guia;
          as outras continuam pendentes para outra guia
        </div>
        <label class="gd-consultation-option" v-for="option in items" :key="option.key"
               :class="{active: option.selected}">
          <input type="radio" name="guide-consultation-item" :checked="option.selected"
                 @change="$emit('select', option)">
          <span class="gd-consultation-option-radio"></span>
          <span class="gd-consultation-option-text">
            <span class="name">{{ option.expense.name }}</span>
            <span class="gd-sub">
              {{ option.expense.code | tuss }}
              <template v-if="option.professionalName"> · {{ option.professionalName }}</template>
              <template v-if="option.return"> · <span class="gd-warn-text">Retorno</span></template>
            </span>
          </span>
          <span class="gd-val" :class="valueClass(option)">
            <span class="loading" v-if="isPricing(option)"></span>
            <fa-icon class="text-error" :icon="['fal', 'lock']"
                     v-else-if="hideInsuranceValue && !option.return"/>
            <template v-else>{{ option.value.total | currency }}</template>
          </span>
        </label>
      </div>

      <div class="empty gd-consultation-empty" v-if="!item">
        <div class="empty-icon"><fa-icon :icon="['fal', 'stethoscope']" size="2x"/></div>
        <p class="empty-title h6">Nenhuma consulta pendente</p>
        <p class="empty-subtitle">
          A guia de consulta precisa de um serviço do tipo consulta neste agendamento
          e neste convênio.
        </p>
      </div>
      <template v-else>
      <div class="columns">
        <div class="column col-5 col-md-12 form-group">
          <label class="form-label">20–21 · Procedimento</label>
          <div class="gd-consultation-procedure">
            <span class="gd-consultation-name" :id="fieldId('items.0.expense')">
              {{ item.expense.name }}
            </span>
          </div>
          <span class="gd-sub">
            {{ item.expense.code | tuss }}
            <template v-if="item.expense.tableCode">
              · tabela {{ item.expense.tableCode }}
            </template>
            <span class="gd-consultation-return" v-if="item.return">
              Retorno · sem cobrança
            </span>
          </span>
        </div>
        <div class="column col-4 col-md-12 form-group"
             :class="{'has-error': professionalError}">
          <label class="form-label">12–16 · Profissional executante</label>
          <template v-if="readonly">
            <div class="gd-read">
              <div class="gd-read-value">{{ item.professionalName || '—' }}</div>
            </div>
          </template>
          <select class="form-select" v-else :id="fieldId('items.0.professionalId')"
                  :value="executantValue" @change="setExecutant($event.target.value)"
                  @blur="touchProfessional">
            <option value="">[Selecione]</option>
            <option v-for="option in professionals" :value="option.value" :key="option.value">
              {{ option.label }}
            </option>
          </select>
          <div class="form-input-hint" v-if="professionalError">Campo obrigatório</div>
          <span class="gd-sub gd-consultation-executant" v-else-if="executantText">
            <template v-if="executantCouncil">{{ executantCouncil }}</template>
            <template v-if="executantCouncil && executantCbo"> · </template>
            <span v-if="executantCbo" :class="{tooltip: !!executantCbo.name}"
                  :data-tooltip="executantCbo.name">CBO {{ executantCbo.code }}</span>
          </span>
          <span class="gd-sub gd-warn" v-else-if="item.professionalId">
            Sem conselho ou CBO cadastrado
          </span>
        </div>
        <div class="column col-3 col-md-12 form-group">
          <label class="form-label">22 · Valor</label>
          <div class="gd-consultation-values">
            <div class="gd-consultation-value main" :class="valueClass(item)">
              <span class="loading" v-if="isPricing(item)"></span>
              <fa-icon class="text-error" :icon="['fal', 'lock']"
                       v-else-if="hideInsuranceValue && !item.return"/>
              <b v-else>{{ item.value.insurance | currency }}</b>
            </div>
          </div>
        </div>
        <div class="column col-12 gd-consultation-status" v-if="statusText || accreditedText">
          <span class="gd-sub gd-err" v-if="item.pricingError">{{ statusText }}</span>
          <span class="gd-sub gd-warn" v-else-if="statusText">{{ statusText }}</span>
          <span class="gd-sub" v-if="accreditedText">{{ accreditedText }}</span>
          <button class="btn btn-sm btn-neutral btn-icon btn-icon-left ml-2"
                  v-if="!readonly && (item.pricingError || !item.priced) && !item.return"
                  :disabled="isPricing(item)" :class="{loading: isPricing(item)}"
                  @click="$emit('change', item)">
            <fa-icon :icon="['fal', 'redo']"/>Recalcular preço
          </button>
        </div>
      </div>
      </template>
    </div>
    <div class="gd-items-error" v-if="hasError">Selecione a consulta desta guia</div>
  </div>
</template>

<script>
export default {
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    v: {
      type: Object,
      default: null,
    },
    professionals: {
      type: Array,
      default: () => [],
    },
    readonly: {
      type: Boolean,
      default: false,
    },
    pricingKeys: {
      type: Array,
      default: () => [],
    },
    hideInsuranceValue: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    item() {
      return this.items.find(found => found.selected) || null;
    },
    showChooser() {
      return !this.readonly && this.items.length > 1;
    },
    hasError() {
      return !!(this.v && this.v.$error);
    },
    professionalNode() {
      if (!this.v || !this.v.items || !this.item) return null;
      const index = this.items.indexOf(this.item);
      return this.v.items.$each ? this.v.items.$each[index] : null;
    },
    professionalError() {
      const node = this.professionalNode;
      return !!(node && node.professionalId && node.professionalId.$error);
    },
    executantValue() {
      if (!this.item || !this.item.professionalId) return '';
      return `${this.item.professionalId}|${this.item.specialtyCode || ''}`;
    },
    executantOption() {
      return this.professionals.find(option => option.value === this.executantValue) || null;
    },
    executantCouncil() {
      const option = this.executantOption;
      const council = option ? option.council : null;
      return council && council.record ? `${council.name}-${council.state} ${council.record}` : '';
    },
    executantCbo() {
      const option = this.executantOption;
      const specialty = option ? option.specialty : null;
      return specialty && specialty.code ? specialty : null;
    },
    executantText() {
      return [this.executantCouncil, this.executantCbo ? `CBO ${this.executantCbo.code}` : '']
        .filter(Boolean)
        .join(' · ');
    },
    accreditedText() {
      return this.item && this.item.accreditedName
        ? `Credenciado no convênio: ${this.item.accreditedName}`
        : '';
    },
    statusText() {
      if (!this.item || this.isPricing(this.item)) return '';
      if (this.item.pricingError) return 'Falha ao calcular o preço';
      if (!this.item.priced && !this.item.return) return 'Sem preço na tabela do convênio';
      return '';
    },
  },
  methods: {
    isPricing(item) {
      return this.pricingKeys.includes(item.key);
    },
    valueClass(item) {
      if (item.return) return 'text-gray';
      return !item.priced && !this.isPricing(item) ? 'gd-warn-text' : '';
    },
    fieldId(path) {
      return `guide-field-${path.replace(/\./g, '-')}`;
    },
    touchProfessional() {
      const node = this.professionalNode;
      if (node && node.professionalId) node.professionalId.$touch();
    },
    setExecutant(value) {
      const [professionalId, specialtyCode] = (value || '').split('|');
      const option = this.professionals.find(found => found.value === value);
      this.item.professionalId = professionalId || null;
      this.item.specialtyCode = specialtyCode || null;
      this.item.professionalName = option ? option.name : null;
      this.$emit('change', this.item);
    },
  },
};
</script>
